/* eslint-disable no-param-reassign */
/**
 * 支持端外跳转各个native播放器，代码取自魔方组件
 * 目前只完善了 微视 新闻 qq浏览器
 */
import atom from '@tencent/vft-atom';
import { mqbHandler } from './mqbrowser';
import { qqnewsHandler } from './news';
import { weishiHandler } from './weishi';

const parseCidVid = (url = '', type = '') => {
  if (!url) return '';

  try {
    const u = new URL(url).searchParams;
    if (type === 'cid') return u.get('cid') || u.get('cover_id') || '';
    if (type === 'vid') return u.get('vid') || u.get('video_id') || '';
    return '';
  } catch (e) {
    return '';
  }
};

/**
 *
 * @param options {
 *   url: 从url解析cid, vid
 *   forceTenvideoApp: 是否强制跳转视频app
 * }
 * @returns
 */
export async function playVideo({
  cid = '',
  vid = '',
  url = '',
  forceTenvideoApp = false,
}): Promise<void> {
  cid = cid || parseCidVid(url, 'cid');
  vid = vid || parseCidVid(url, 'vid');

  if (!forceTenvideoApp) {
    // 在各个端中打开视频播放
    if (await weishiHandler({ cid, vid })) return;
    if (await qqnewsHandler({ cid, vid })) return;
    if (await mqbHandler({ cid, vid })) return;
  }

  if (url) {
    atom.openUrl(url);
  } else if (cid || vid) {
    atom.play(cid, vid);
  }
}
